export type CoverageLevel = 'lowest_cost' | 'best_fit' | 'better_benefits'

export const AllowanceStrategies = {
  Smart: 'smart',
  Flat: 'flat',
}

export type AllowanceStrategy = typeof AllowanceStrategies[keyof typeof AllowanceStrategies]

export type FiltersValues = {
  coverageLevel: CoverageLevel
  employerEmployeeContribution: number
  employerSpouseContribution: number
  employerChildContribution: number
}

export type CoverageLevelPill = {
  text: string
  isPositive: boolean
}
